import React from 'react';
import PropTypes from "prop-types";
import { SelectDropdownStyles } from '../styles';
import { Form, Row, Col } from 'antd';
import MutualFund from './MutualFund';
import { withRouter } from 'react-router-dom';
import VanguardAccountNumber from "../../CommonComponents/InputComponent/VanguardAccountNumber";
import DropDownComponent from "../../CommonComponents/DropDownComponent/DropDown";
import DonorDetails from "./DonorDetails";

class MutualFundForm extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <Form hideRequiredMark>
                    <Row>
                    <Col lg={{span:8}} md={{span:8}}>
                        <SelectDropdownStyles>
                            <DropDownComponent assetHeld="assetOutsideVG" accountId={this.props.accountId} contributionType={this.props.contributionType} label="Type of account in which assets are registered" traverse="corporateInformation" giftLength={this.props.count}/>
                        </SelectDropdownStyles>
                        </Col>
                    </Row>
                    { (this.props.type !== "Select Account Type") ?
                        <Row>
                        <DonorDetails assetHeld="assetOutsideVG" accountId={this.props.accountId} contributionType={this.props.contributionType} type={this.props.type} count={this.props.count}/>
                        </Row>
                        : null
                    }
                    <Row>
                        <Col lg={{ span: 8 }} md={{span:8}} >
                            <VanguardAccountNumber label={(this.props.contributionType === "mutualFund") ? "Holding firm" : "Brokerage firm"} property="holdingFirm" assetHeld="assetOutsideVG" accountId={this.props.accountId} contributionType={this.props.contributionType} giftLength={this.props.count}/>
                        </Col>
                        <Col lg={{ span: 8, offset: 1 }} md={{ span: 8, offset: 1 }}>
                            <VanguardAccountNumber offset={1} label="Account number (optional)" property="accountNumber" assetHeld="assetOutsideVG" accountId={this.props.accountId} contributionType={this.props.contributionType} giftLength={this.props.count}/>
                        </Col>
                    </Row>
                    <Row>
                        <MutualFund assetHeld="assetOutsideVG" accountId={this.props.accountId} count={this.props.count} contributionType={this.props.contributionType}/>
                    </Row>
                </Form>
            </>
        )
    }
}

const MutualFundAccount = Form.create({ name: "mutualFundAccount" })(MutualFundForm);

MutualFundAccount.propTypes = {
    accountId: PropTypes.number,
    contributionType: PropTypes.string,
    type: PropTypes.string,
    count: PropTypes.number,
}

export default withRouter(MutualFundAccount);